import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { mapLoginErrorToMessage, useAuth } from '@ibk/shared-auth';
import { clearPendingDomains, clearPermissioningCache, clearUser, PersonDocumentType, useAppDispatch, useLazyHasAccessQuery, } from '@ibk/shared-config';
import { useTranslation } from '@ibk/shared-translation';
import { LoginErrorsType } from '@ibk/shared-types';
export function useLoginClient() {
    const { login, isLoggedIn, loading, error, isAuthenticated } = useAuth();
    const [hasAccess] = useLazyHasAccessQuery();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [cpf, setCpf] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [cpfTouched, setCpfTouched] = useState(false);
    const [showInlineError, setShowInlineError] = useState(true);
    const [localClientError, setLocalClientError] = useState('');
    const [clientErrorMessage, setClientErrorMessage] = useState('');
    const [isMaintenanceOpen, setIsMaintenanceOpen] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        if (error === LoginErrorsType.MAINTENANCE) {
            setClientErrorMessage('');
            setIsMaintenanceOpen(true);
        }
        else if (error) {
            setClientErrorMessage(mapLoginErrorToMessage(error, t));
        }
        else if (localClientError) {
            setClientErrorMessage(localClientError);
        }
        else {
            setClientErrorMessage('');
        }
    }, [error, localClientError, t]);
    useEffect(() => {
        if (isLoggedIn && !isAuthenticated) {
            navigate('/two-factor-select', { replace: true });
        }
    }, [isLoggedIn, navigate, isAuthenticated]);
    const handleLogin = async (cpf, password) => {
        setLocalClientError('');
        const cleanDocumentNumber = cpf.replace(/\D/g, '');
        try {
            dispatch(clearPermissioningCache());
            dispatch(clearPendingDomains());
            dispatch(clearUser());
            await login(cleanDocumentNumber, password);
            try {
                await hasAccess({ documentNumber: cleanDocumentNumber, documentType: PersonDocumentType.CPF }).unwrap();
            }
            catch (userError) {
            }
        }
        catch (err) {
            if (err instanceof Error) {
                if (err.message === LoginErrorsType.INVALID_CREDENTIALS) {
                    setLocalClientError(t('auth.error.invalid-credentials'));
                }
                else {
                    setLocalClientError(t('auth.error.generic'));
                }
            }
        }
    };
    return {
        cpf,
        setCpf,
        password,
        setPassword,
        showPassword,
        setShowPassword,
        cpfTouched,
        setCpfTouched,
        showInlineError,
        setShowInlineError,
        clientErrorMessage,
        isLoading: loading,
        isMaintenanceOpen,
        closeMaintenance: () => setIsMaintenanceOpen(false),
        handleLogin,
    };
}
